import { env } from '../configs/env.config'
import { FairFashion, FairFashionOptions } from '../sdk'

export const sdk = ((): FairFashion => {
  const token = localStorage.getItem(env.LOCAL_STORAGE_LOGIN_TOKEN)
  const options: FairFashionOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    baseURL: env.FAIRFASHION_URL,
  }

  return new FairFashion(options)
})()
